import { formatAbsolute, formatRelative } from '@/lib/format';
import { useNow } from '@/lib/hooks';
import { cn } from '@/lib/utils';

export function RelativeTime({ value, className, fallback = '—' }: { value: string | null | undefined; className?: string; fallback?: string }) {
  // useNow() only drives periodic re-renders; compare against the real clock so fresh events never look like they are in the future.
  useNow();
  if (!value) return <span className={cn('text-muted-foreground', className)}>{fallback}</span>;
  return (
    <time dateTime={value} title={formatAbsolute(value, true)} className={cn('whitespace-nowrap', className)}>
      {formatRelative(value, Date.now())}
    </time>
  );
}
